/**
 * Role rules — one implementation, enforced server-side, mirrored client-side
 * (docs/08 §1). Phase 1 covers the board-level actions; F-25 protected-range
 * checks slot in here later.
 */
export const ROLES = ["admin", "editor", "commenter", "viewer"];
/**
 * Actions used in Phase 1, plus `review.approve`.
 *
 * `review.approve` is the PROJECT MANAGER gate on the two pre-production
 * tracks (storyboard and BGM): submitting a track for review is ordinary
 * `board.edit` work, but signing one off — which is what auto-advances the
 * board to shooting — is not. Modelled as its own action rather than as
 * `role === "admin"` checks sprinkled through the routes, so the rule lives
 * in one table and a real `project_manager` role can be granted it later
 * without hunting for comparisons.
 *
 * `kinds.manage` (2026-09-04) is the same shape for the `/` menu's
 * admin-defined script line kinds (F-17-type): defining a keyword and its
 * style is a PROJECT MANAGER's job, not a writer's. Admin-only today, for the
 * same reason as `review.approve`; a PM role gets it in the same one-line edit.
 */
export const ACTIONS = [
    "board.create",
    "board.edit",
    "board.view",
    "review.approve",
    "admin.settings",
    "kinds.manage",
];
const GRANTS = {
    admin: new Set([
        "board.create",
        "board.edit",
        "board.view",
        "review.approve",
        "admin.settings",
        "kinds.manage",
    ]),
    editor: new Set(["board.create", "board.edit", "board.view"]),
    commenter: new Set(["board.view"]),
    viewer: new Set(["board.view"]),
};
/** Can `role` perform `action`? */
export function can(role, action) {
    return GRANTS[role].has(action);
}
export function isRole(value) {
    return typeof value === "string" && ROLES.includes(value);
}
//# sourceMappingURL=permissions.js.map